import { useMemo } from "react";
import classNames from "classnames";

import {
  LargeBlueTicket,
  LargeGreenTicket,
  LargeOrangeTicket,
  LargePinkTicket,
  LargePurpleTicket,
} from "../../AscIllustrations";
import { MoreIcon } from "../../AscIcons";

import styles from "./AscAdminChallengeCard.module.scss";
import AscParagraph from "../../AscTypography/AscParagraph/AscParagraph";

export type AscAdminChallengeCardColor =
  | "TEAL"
  | "PINK"
  | "GREEN"
  | "PURPLE"
  | "ORANGE";
export interface AscAdminChallengeCardProps {
  title: string;
  badgeColor?: AscAdminChallengeCardColor | string;
  className?: string;
  imageUrl?: string;
  onClick?: () => void;
}

export default function AscAdminChallengeCard({
  title,
  badgeColor = "TEAL",
  className,
  imageUrl,
  onClick,
}: AscAdminChallengeCardProps) {
  const badge = useMemo(() => {
    switch (badgeColor) {
      case "TEAL":
        return <LargeBlueTicket className={styles.badge} />;
      case "PINK":
        return <LargePinkTicket className={styles.badge} />;
      case "GREEN":
        return <LargeGreenTicket className={styles.badge} />;
      case "ORANGE":
        return <LargeOrangeTicket className={styles.badge} />;
      case "PURPLE":
        return <LargePurpleTicket className={styles.badge} />;
    }
  }, [badgeColor]);

  return (
    <div className={classNames(styles.ground, className)} onClick={onClick}>
      <div className={styles.topContent}>
        <span className={styles.badgeField}>{badge}</span>
        {imageUrl ? (
          <img src={imageUrl} alt={imageUrl} className={styles.image} />
        ) : (
          <div className={styles.noImage} />
        )}
      </div>
      <div className={styles.content}>
        <AscParagraph className={styles.title}>{title} Challange</AscParagraph>

        <MoreIcon className={styles.moreIcon} />
      </div>
    </div>
  );
}
